module.exports = __webpack_public_path__ + "static/media/consumergoods3.25b33b0a.png";